/**
 * Helpers para upload com retry automático em redes instáveis.
 *
 * - Tenta uploads múltiplas vezes (default 3) com backoff exponencial: 500ms, 1500ms, 4500ms
 * - Considera apenas erros de rede / 5xx como retryable
 * - 4xx (validação, auth) NÃO é retried — falha imediato
 */

const RETRYABLE_STATUS = new Set([0, 408, 429, 500, 502, 503, 504]);

function isRetryable(err) {
  // erro de rede sem response (timeout, conexão cortada) ou status retryable
  if (!err.response) return true;
  return RETRYABLE_STATUS.has(err.response.status);
}

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

/**
 * Executa uma função de upload com retry exponencial.
 * @param {() => Promise<any>} uploadFn  função que faz o POST e retorna a resposta
 * @param {{ maxAttempts?: number, onRetry?: (attempt:number, err:any) => void }} opts
 */
export async function uploadWithRetry(uploadFn, { maxAttempts = 3, onRetry } = {}) {
  let lastErr;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await uploadFn();
    } catch (err) {
      lastErr = err;
      if (attempt < maxAttempts && isRetryable(err)) {
        onRetry?.(attempt, err);
        // backoff: 500ms, 1500ms, 4500ms
        await sleep(500 * Math.pow(3, attempt - 1));
        continue;
      }
      throw err;
    }
  }
  throw lastErr;
}
